import { BoxProps, StyledComponentProps } from "@mui/material";
import { StyledEngineProviderProps } from "@mui/styled-engine/StyledEngineProvider";
import { Box, styled } from "components/common";

const drawerWidth = 250;
interface CustomBoxProps extends BoxProps {
  open?: boolean;
}

export const ProductsWrapper = styled(Box)<CustomBoxProps>(
  ({ theme, open }) => ({
    display: "flex",
    height: "auto",
    margin: "24px 24px",
    gap: open ? theme.spacing(3) : 0,
    "& .left": {
      minWidth: open ? drawerWidth : 0,
      width: open ? drawerWidth : 0,
      overflowX: open ? "visible" : "hidden",
      transitionProperty: "all",
      transitionDuration: "225ms",
      TransitionTimingFunction: "cubic-bezier(0.4,0,0.6,1)",
    },
    "& .right": {
      width: "100%",
    },
  })
);
